import axios from "axios";
import { notification } from "antd";
import config from "../config/config";


// Add a request interceptor to always use the latest token
axios.interceptors.request.use(
  (config_req) => {
    localStorage.setItem("last_activity", Date.now().toString());
    const token = localStorage.getItem(config.jwt_store_key);
    if (token) {
      config_req.headers.Authorization = `Bearer ${token}`;
    }
    return config_req;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle session expiration (401/403)
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Skip session expired handling for login attempts
      if (error.config?.url?.includes("auth/login")) {
        return Promise.reject(error);
      }

      // Session expired or unauthorized
      localStorage.removeItem(config.jwt_store_key);
      
      // Prevent multiple notifications or redirects if many requests fail at once
      if (window.location.pathname !== "/login") {
        notification["error"]({
          message: "Session Expired",
          description: "Your session has expired or is invalid. Please login again.",
        });
        
        // Use a small delay to allow the notification to be seen/processed
        setTimeout(() => {
          window.location.href = "/login";
        }, 1000);
      }
    }
    return Promise.reject(error);
  }
);

const http = {
  get: async (url) => {
    try {
      const response = await axios.get(url);
      
      // Check HTTP status, not data.status
      if (response.status === 200) {
        return response.data; // Return the actual data
      }
      
      if (response.status >= 400 && response.status <= 499) {
        notification["error"]({
          message: response.data?.message || "Request failed",
        });
        return null;
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error ||
                          error.message ||
                          "Internal Server Error";
      notification["error"]({
        message: errorMessage,
      });
      console.log("error details:", {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message,
        url: url
      });
      return null;
    }
  },

  post: async (url, request, options = {}) => {
    try {
      const response = await axios.post(url, request, options);
      
      if (response.status === 200 || response.status === 201) {
        return response.data;
      }
      
      if (response.status >= 400 && response.status <= 499) {
        notification["error"]({
          message: response.data?.message || "Request failed",
        });
        return null;
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error ||
                          error.message ||
                          "Internal Server Error";
      notification["error"]({
        message: errorMessage,
      });
      console.log("error details:", {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message,
        url: url
      });
      return null;
    }
  },

  put: async (url, request) => {
    try {
      const response = await axios.put(url, request);
      
      if (response.status === 200) {
        return response.data;
      }
      
      if (response.status >= 400 && response.status <= 499) {
        notification["error"]({
          message: response.data?.message || "Request failed",
        });
        return null;
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error ||
                          error.message ||
                          "Internal Server Error";
      notification["error"]({
        message: errorMessage,
      });
      console.log("error details:", {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message,
        url: url
      });
      return null;
    }
  },

  patch: async (url, request) => {
    try {
      const response = await axios.patch(url, request);
      if (response.status === 200) {
        return response.data;
      }
      if (response.status >= 400 && response.status <= 499) {
        notification["error"]({
          message: response.data?.message || "Request failed",
        });
        return null;
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error ||
                          error.message ||
                          "Internal Server Error";
      notification["error"]({
        message: errorMessage,
      });
      console.log("error details:", {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message,
        url: url
      });
      return null;
    }
  },

  delete: async (url) => {
    try {
      const response = await axios.delete(url);
      
      if (response.status === 200) {
        return response.data;
      }
      
      if (response.status >= 400 && response.status <= 499) {
        notification["error"]({
          message: response.data?.message || "Request failed",
        });
        return null;
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error ||
                          error.message ||
                          "Internal Server Error";
      notification["error"]({
        message: errorMessage,
      });
      console.log("error details:", {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message,
        url: url
      });
      return null;
    }
  },
};

export default http;